<template>
  <div class="screen-chronology" v-if="isPrivate">
    <v-card class="header-card pa-3" height="82" tile>
      <div class="d-flex mb-2">
        <div class="body-2 font-weight-bold">
          クロノロジー v {{ appVersion }}
        </div>
        <v-spacer></v-spacer>
        <v-btn x-small @click="reload()" class="ml-2" light v-if="false">
          更新
        </v-btn>
        <ChronologyNotification />
      </div>
      <v-card class="d-flex align-center" color="transparent" flat tile>
        <v-tabs background-color="transparent" color="primary" height="34">
          <v-tab @click="nav = 'list'">
            <v-icon left small>
              mdi-format-list-bulleted
            </v-icon>
            <span>リスト</span>
          </v-tab>
          <v-tab @click="nav = 'map'">
            <v-icon left small>
              mdi-map-marker
            </v-icon>
            <span>マップ</span>
          </v-tab>
        </v-tabs>
      </v-card>
    </v-card>

    <div class="nav-area">
      <ChronologyListScreen
        ref="chronologyList"
        :map="map"
        height="100%"
        class="mx-2"
        v-show="nav === 'list'"
      />
      <LMap
        ref="screenChronologyMap"
        id="screenChronologyMap"
        :zoom="14"
        :center="center"
        :options="{ zoomControl: false, scrollWheelZoom: true }"
        :zoom-animation="false"
        style="height: 100%"
        v-show="nav === 'map'"
      >
        <LTileLayer :url="tileLayerUrl" />
        <ChronologyLayer :map="map" />
      </LMap>
    </div>
  </div>
</template>
<script>
import { LMap, LTileLayer } from "vue2-leaflet";
import { BRANCH_OFFICE } from "../enums/BranchOffice";
import ChronologyListScreen from "../components/chronology/ChronologyListScreen";
import ChronologyLayer from "../components/chronology/ChronologyLayer";
import ChronologyNotification from "../components/chronology/ChronologyNotification";
export default {
  name: "ScreenChronology",
  components: {
    LMap,
    LTileLayer,
    ChronologyListScreen,
    ChronologyLayer,
    ChronologyNotification
  },
  data() {
    return {
      center: [BRANCH_OFFICE[0].lat, BRANCH_OFFICE[0].lng],
      nav: "list",
      map: null,
      tileLayerUrl: "https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png"
    };
  },

  computed: {
    appVersion() {
      if (process.env.VUE_APP_CHRONOLOGY_ALIAS === "stage") {
        return process.env.VUE_APP_VERSION ? process.env.VUE_APP_VERSION : "";
      } else {
        return "";
      }
    },
    isPrivate() {
      return process.env.VUE_APP_MODE === "private";
    }
  },

  watch: {
    nav(val) {
      if (val === "list") {
        this.$refs.chronologyList.refresh();
      } else if (val === "map") {
        this.$nextTick(() => {
          this.map.invalidateSize();
        });
      }
    }
  },

  async created() {
    //
  },

  beforeDestroy() {
    //
  },

  async mounted() {
    if (!this.map) {
      this.map = this.$refs.screenChronologyMap.mapObject;
    }
  },

  methods: {
    async reload() {
      window.location.reload(true);
    }
  }
};
</script>

<style lang="scss" scoped>
.screen-chronology {
  .header-card {
    background-color: #f7f7f7;
    color: #7d7d7d;
  }
}
.nav-area {
  padding-top: 2px;
  height: calc(100dvh - 82px);
}
</style>
